// Central config for external links used by CTAs.

export const CALENDLY_URL =
  "https://calendly.com/dpaul-smartedgebizsolutions/introduction-to-smart-business-solutions-with-dan-paul";

export const CONTACT_EMAIL = "info@smartedgebizsolutions.com";
export const CONTACT_PHONE_DISPLAY = "614-203-5952";
export const CONTACT_PHONE_TEL = "+16142035952";

/**
 * Open the Calendly booking widget as an in-page popup.
 * Falls back to opening the URL in a new tab if the Calendly script
 * has not loaded yet (e.g. offline / adblock).
 */
export const openCalendly = () => {
  if (typeof window === "undefined") return;
  if (window.Calendly && typeof window.Calendly.initPopupWidget === "function") {
    window.Calendly.initPopupWidget({ url: CALENDLY_URL });
    return;
  }
  window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
};
